<mat-radio-button
  [id]="id ? id : ''"
  [name]="name!"
  [value]="value"
  [color]="color"
  [disabled]="disabled"
  [checked]="checked"
  [labelPosition]="labelPosition"
  [attr.aria-label]="ariaLabel"
  [attr.aria-labelledby]="ariaLabelledby"
  [attr.aria-describedby]="ariaDescribedby"
  [ngClass]="cssClass"
  (change)="onRadioChange($event)"
  (click)="radioClicked($event)"
>
  <ng-content></ng-content>
</mat-radio-button>
